import Cookies from "js-cookie";
import apiClient from "../services/apiService";

//logout
export const logout = async () => {
  try {
    await apiClient.post("/admin/logout");
  } catch (error) {
    console.error("Logout failed:", error);
  } finally {
    Cookies.remove("authToken");
    Cookies.remove("userName");
    Cookies.remove("userId");
    window.location.href = "/login";
  }
};
